const PaymentTypes = {
  PLUS_GIRO: 1,
  BANK_GIRO: 2,
  CASH: 3,
  DIRECT_DEBIT: 4,
  SYSTEM: 5,
  PAYMENT_PLAN: 6,
  BAD_DEBT_EXPENSE: 8,
  EARLY_REPAYMENT: 9,
  ELECTRONIC_INVOICE: 10,
  UNPAID_PAYOUT: 11,
  ONE_CLICK: 12,
  DIRECT_TRANSFER: 13,
  ACCOUNT_TRANSFER: 14,
  PAID_WITH_CREDITS: 101
}

const InvoiceTypes = {
  REGULAR: 1,
  CREDIT: 2,
  ADDITIONAL: 3,
  FINAL: 4,
  FEE: 5,
  GROUP: 7
}

const InvoiceStatuses = {
  UNPAID: 1,
  OVERPAID: 2,
  PARTLY_PAID: 3,
  FULLY_PAID: 4,
  CREDITED: 5,
  OVERDUE: 6,
  CLAIM_TRANSMITTED: 9,
  REFUNDED: 5000002
}

const ConsentStatuses = {
  REGISTERED: 1,
  SENT: 2,
  APPROVED: 3,
  STOPPED: 4
}

const PayoutMethods = {
  ACCOUNT: 1,
  PAPER: 2
}

const BankIdSigningActions = {
  MOBILE: 1,
  QR_CODE: 2
}

export {
  PaymentTypes,
  InvoiceStatuses,
  InvoiceTypes,
  ConsentStatuses,
  PayoutMethods,
  BankIdSigningActions
}
